import { InterceptorClient } from "../../interceptor/interceptorClient";
import {
  ADDRESS_TO_USER,
  ASSIGN_ROOM,
  CREATE_ROOM,
  GET_ASSIGNED_PERSON,
  GET_RECEIVER_ADDRESS,
  GET_REVEAL_INFO,
  GET_ROOM_INFO,
  GET_USER_ADDRESS,
  JOIN_ROOM,
  SAVE_ADDRESS,
  TRENDING_PRODUCTS,
} from "./constant";

const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;
const headers = {
  "Content-Type": "application/x-www-form-urlencoded",
  "x-api-version": "v1.4",
};

/** */
export async function createNewRoom(params) {
  try {
    return await InterceptorClient.getGatewayInstance().post(params, `${CREATE_ROOM()}`, false);
  } catch (error) {
    throw new Error(error.message);
  }
}
/** */
export async function addAddress(params) {
  try {
    return await InterceptorClient.getGatewayInstance().post(params, `${SAVE_ADDRESS()}`, false);
  } catch (error) {
    throw new Error(error.message);
  }
}
/** */
export async function joinRoom(params) {
  try {
    return await InterceptorClient.getGatewayInstance().post(params, `${JOIN_ROOM()}`, false);
  } catch (error) {
    throw new Error(error.message);
  }
}
/** */
export async function getRoomInfo(userId) {
  try {
    return await InterceptorClient.getGatewayInstance().get(`${GET_ROOM_INFO(userId)}`);
  } catch (error) {
    throw new Error(error.message);
  }
}
/** */
export async function assignRoom(params) {
  try {
    return await InterceptorClient.getGatewayInstance().post(params, `${ASSIGN_ROOM()}`, false);
  } catch (error) {
    throw new Error(error.message);
  }
}
/** */
export async function getUserAddress(userId) {
  try {
    return await InterceptorClient.getGatewayInstance().get(`${GET_USER_ADDRESS(userId)}`);
  } catch (error) {
    throw new Error(error.message);
  }
}

/** */
export async function getAssignedUsedDetails(roomId, userId) {
  try {
    return await InterceptorClient.getGatewayInstance().get(`${GET_ASSIGNED_PERSON(roomId, userId)}`);
  } catch (error) {
    throw new Error(error.message);
  }
}

/** */
export async function addNewAddressToUser(params) {
  const urlParams = new URLSearchParams(params);
  try {
    const response = await InterceptorClient.getFNTSInstance(baseUrl).post(
      urlParams,
      ADDRESS_TO_USER(),
      false,
      headers,
    );
    return response;
  } catch (error) {
    console.log(error);
  }
}

/** */
export const fetchTrendingProducts = async () => {
  try {
    const res = await InterceptorClient.getGatewayInstance().get(`${TRENDING_PRODUCTS()}`, false);
    return res;
  } catch (error) {
    console.error(
      "Error occurred while fetching to Santa Trending Products:",
      error.message || "Something went wrong!",
    );
  }
};

/** */
export const fetchReceiverAddressInfo = async (roomId, userId) => {
  try {
    const res = await InterceptorClient.getGatewayInstance().get(`${GET_RECEIVER_ADDRESS(roomId, userId)}`, false);
    return res;
  } catch (error) {
    console.error(error?.message);
  }
};

/** */
export const fetchRevealInfo = async (roomId, userId) => {
  try {
    const res = await InterceptorClient.getGatewayInstance().get(`${GET_REVEAL_INFO(roomId, userId)}`, false);
    return res;
  } catch (error) {
    console.error(error?.message);
  }
};
